module.exports = __webpack_public_path__ + "static/media/menuAI.7c859e00.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/menuAI.svg
// module id = 461
// module chunks = 0